import MailLockIcon from "@mui/icons-material/MailLock"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

import LoadingPaper from "../components/LoadingPaper"

export default function ForgotPasswordEmailSent() {
  return (
    <Box sx={{ mt: (theme) => theme.spacing(2) }}>
      <LoadingPaper>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <MailLockIcon fontSize="large" color="info" />
        </Box>
        <Typography
          variant="h5"
          textAlign="center"
          sx={{ mt: (theme) => theme.spacing(2) }}
        >
          Password reset email is on the way!
        </Typography>
        <Typography variant="body1" sx={{ mt: (theme) => theme.spacing(1) }}>
          Please check your inbox for further instructions
        </Typography>
      </LoadingPaper>
    </Box>
  )
}
